export default __webpack_public_path__ + "static/media/reveal-devices.6eef70b5.png";